// import lib
import isEmpty from '../../lib/isEmpty';

const validation = value => {
    let errors = {};

    if (isEmpty(value.newPhoneCode)) {
        errors.newPhoneCode = "Required"
    }

    if (isEmpty(value.newPhoneNo)) {
        errors.newPhoneNo = "Required"
    }

    if (isEmpty(value.otp)) {
        errors.otp = "Required"
    }

    return errors;
}

export default validation;